import VuexPersistence from 'vuex-persist'
import Vuex from 'vuex'

import documentModule from './module-document'
import areaPubblicaModule from './module-area-pubblica'
import blogModule from './module-blog'
import reservedAreaModule from './module-reserved-area'
import expertsModule from './module-experts'

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  // reducer: (state) => ({
  //   translations: state.translations,
  //   factory: state.factory,
  //   kpi: state.kpi,
  //   shifts_management: state.shifts_management,
  //   maintenance: state.maintenance,
  //   platform_user_management: state.platform_user_management,
  //   ui_customizations: state.ui_customizations,
  //   production_downtime: state.production_downtime,
  //   documents: state.documents,
  //   shopfloor_shiftbook: state.shopfloor_shiftbook,
  //   device_management: state.device_management,
  //   app_info: state.app_info,
  //   mobile_management: state.mobile_management
  // }),
})

const store = Vuex.createStore({
  plugins: [vuexLocal.plugin],
  modules: {
    documentModule,
    areaPubblicaModule,
    blogModule,
    reservedAreaModule,
    expertsModule,
  },
})

export default store
